<!-- START: Section 2 -->
<section class="dev-benefit">
  <div class="box-container">
    <div class="benefit-topic">
      <!-- desktop heading-->
      <div
        class="benefit-topic__heading benefit-topic__heading--desktop color-gray"
        [innerHtml]="'WORK_WITH_US.DEV_BENEFIT_SECTION.HEADING' | translate"
      >
      </div>

      <!-- tablet heading-->
      <div
        class="benefit-topic__heading benefit-topic__heading--tablet color-gray"
        [innerHtml]="'WORK_WITH_US.DEV_BENEFIT_SECTION.HEADING_TABLET' | translate"
      >
      </div>

      <!-- mobile heading -->
      <div
        class="benefit-topic__heading benefit-topic__heading--mobile color-gray"
        [innerHtml]="'WORK_WITH_US.DEV_BENEFIT_SECTION.HEADING_MOBILE' | translate"
      >
      </div>

      <div class="benefit-topic__heading-detail">
        {{ 'WORK_WITH_US.DEV_BENEFIT_SECTION.DETAIL' | translate }}
      </div>
    </div>

    <div class="box">
      <div class="box__left">
        <ng-container *ngFor="let i of counter(6); let item = index">
          <div class="box__item">
            <div class="box__detail-section">
              <i class="fas fa-check color-blue"></i>
              <div class="box__item--detail">{{
                'WORK_WITH_US.DEV_BENEFIT_SECTION.ITEM.MESSAGE_' + (item + 1) | translate
              }}</div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="box__right">
        <picture>
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/work-with-us/section5/good_for_you-v2.webp"
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/work-with-us/section5/good_for_you-v2.png"
            width="100%"
            loading="lazy"
            alt="dev benefit good for you"
            class="box__image"
          />
        </picture>
      </div>
    </div>
  </div>
</section>
<!-- END: Section 2 -->
